import React from "react";
import { onboardingRoutePaths } from "./onboarding.route.config";
import Stepper from "@/pages/admin/Stepper/Stepper";

const OnboardingRoutes = {
    STEPPER_FORM: {
        ...onboardingRoutePaths.STEPPER_FORM,
        element: <Stepper />
    }
}

export {
    OnboardingRoutes
}